import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { MenuIcon } from 'lucide-react';
const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  return <div className="flex h-screen bg-secondary-50" data-id="element-45">
      <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} data-id="element-46" />
      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-47">
        <Header toggleSidebar={() => setSidebarOpen(!sidebarOpen)} data-id="element-48" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-49">
          <Outlet data-id="element-50" />
        </main>
      </div>
    </div>;
};
export default AdminLayout;